import { CheckCircle2 } from "lucide-react";

const wins = [
  "Entri in ogni testo con una direzione chiara, senza leggere a vuoto.",
  "Trasformi ciò che leggi in parole tue: lo capisci, non lo memorizzi.",
  "Colleghi le informazioni e costruisci un discorso solido.",
  "Arrivi all'esame sapendo spiegare tutto senza dipendere dal libro.",
];

export default function Solution() {
  return (
    <section id="manuale" className="relative py-16 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5982c5]">La svolta</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1f2937]">
            Ecco <span className="text-[#5982c5]">ComprehensionUp</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#4b5563]">
            Un manuale digitale che non ti chiede di ripartire da zero. Ti insegna a fare meglio ciò che
            già fai, con un processo pratico in <strong className="text-[#1f2937]">4 fasi</strong>:
            <span className="text-[#5982c5] font-semibold"> Attenzione, Elaborazione, Collegamento ed Esposizione</span>.
            Metodo flessibile, applicabile ai tuoi testi reali fin dalla prima pagina.
          </p>

          <ul className="mt-8 space-y-4">
            {wins.map((w, i) => (
              <li key={i} className="flex items-start gap-3">
                <CheckCircle2 size={24} className="text-[#f0d203] fill-[#5982c5] shrink-0 mt-0.5" />
                <span className="text-[#1f2937] leading-relaxed font-medium">{w}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 inline-flex items-center gap-3 bg-[#ecfef7] rounded-2xl px-5 py-4 border border-[#5982c5]/15">
            <p className="font-heading font-semibold text-[#1f2937]">
              “La comprensione si misura da quanto riesci a usare un testo, non da quanto ti sembra familiare.”
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute inset-0 bg-[#5982c5]/10 rounded-[2.5rem] rotate-3" />
          <img
            src="https://images.pexels.com/photos/7972382/pexels-photo-7972382.jpeg"
            alt="Studentessa sicura mentre studia con il tablet"
            className="relative w-full h-[460px] object-cover rounded-[2rem] shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
          />
        </div>
      </div>
    </section>
  );
}
